import { ReactNode } from "react";

type PatientPageHeadingProps = {
  title: string;
  description?: string;
  actions?: ReactNode;
};

export default function PatientPageHeading({ title, description, actions }: PatientPageHeadingProps) {
  return (
    <div
      className="flex flex-col gap-3 rounded-[10px] border px-4 py-3 backdrop-blur-md md:flex-row md:items-start md:justify-between"
      style={{
        borderColor: "rgba(255,255,255,0.75)",
        background: "linear-gradient(180deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0.18) 100%)",
      }}
    >
      <div>
        <h1 className="text-xl font-semibold text-white md:text-2xl">{title}</h1>
        {description && <p className="mt-1 text-sm text-white/90">{description}</p>}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
